module.exports = __webpack_public_path__ + "static/media/riven-lose.4c46beca.png";